import { createSelector } from 'reselect'
import { RootStoreState } from '@src/models/app.types'

const policyConsentsStateSelector = (state: RootStoreState) => state.policyConsents

export const policyConsentStatusesSelector = createSelector(
  policyConsentsStateSelector,
  (policyConsents) => policyConsents.statuses,
)
